import { PriorityInfo, StatusInfo, TableOptions } from "./types";

export const statusType: StatusInfo[] = [
  { value: "TODO", severity: "info", translationKey: "word.to-do" },
  { value: "IN_PROGRESS", severity: "warning", translationKey: "word.in-progress" },
  { value: "DONE", severity: "success", translationKey: "word.done" },
  { value: "CANCELLED", severity: "danger", translationKey: "word.cancelled" },
]

export const priorityType: PriorityInfo[] = [
  { value: "HIGHEST", severity: "red", icon: "pi pi-angle-double-up", translationKey: "word.highest" },
  { value: "HIGH", severity: "red", icon: "pi pi-angle-up", translationKey: "word.high" },
  { value: "MEDIUM", severity: "orange", icon: "pi pi-bars", translationKey: "word.medium" },
  { value: "LOW", severity: "blue", icon: "pi pi-angle-down", translationKey: "word.low" },
  { value: "LOWEST", severity: "blue", icon: "pi pi-angle-double-down", translationKey: "word.lowest" },
]
export const measurementOrder = ["Darbo valandos", "Q", "V", "T1", "T2", "P", "D", "Klaida"];

export const STATUS_UPDATE_TIME = 60 * 1000;

export const DATA_EXPORT_LIMIT = 200;
export const CHUNK_SIZE = 100;

export const ENUM_OPS = ["EQ", "NEQ"];
export const NUM_OPS = ["EQ", "NEQ", "GT", "GTE", "LT", "LTE"];

export const initialFilter: TableOptions = {
  first: 0,
  rows: 10,
  page: 0,
  sortField: "",
  sortOrder: 1,
  multiSortMeta: [],
  filters: {},
  filter: null,
  andFilters: [],
  search: "",
  reqSortField: "",
};